export default __webpack_public_path__ + "static/media/DTEX-UC2-Seq5c-Reports-Digital-FileLineage-Full.c3c5055f.png";